import { themeOptionFactory as kioskV } from "./kiosk-v"
import { themeOptionFactory as mobile } from "./mobile"

export const themeOptionFactories = {
  mobile: mobile,
  "kiosk-v": kioskV,
  "kiosk-h": null,
}
